export default __webpack_public_path__ + "static/media/harshit.f6952a63.pdf";